import React, { useEffect, useState } from "react";
import {
  Count,
  Title,
  CollapseTitle,
  CustomContainer,
  CustomBox,
} from "../../commonElements";
import AvailableRoom from "./availableRoom";
import SelectedRoom from "./selectedRoom";
import StayOptions from "../stayOptions";
import { Collapse } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { roomSelector, setRoomIsActive, removeSelectedRoom, triggerRoomApi } from "../rooms/roomSlice";
import { Abtest } from "../../mixpanel";

function SectionB({ setQueryDetails, queryDetails }) {
  const dispatch = useDispatch();
  const roomState = useSelector(roomSelector);
  const [packageCollpase, setPackageCollapse] = useState(false);
  const [roomCollpase, setRoomCollapse] = useState(false);
  const [accessibleRoomCollapse, setAccessibleRoomCollapse] = useState(false);

  useEffect(() => {
    if (roomState?.selectedRoom?.length > 0) {
      setRoomCollapse(false);
      setAccessibleRoomCollapse(false);
      setPackageCollapse(false)
    }
  }, [roomState.selectedRoom]);

  const handleRoomRemove = (idx,e) => {
    e.stopPropagation();
    dispatch(removeSelectedRoom({index: idx}));
    console.log(roomState.selectedRooms);
  }

  return (
    <CustomContainer className="bg-main lg:bg-white pt-[32px] pb-[20px] lg:pb-0 mt-[44px] lg:mt-0">
      <Abtest
        VariantA={
          <>
            <Count count={"2"} />
            <Title
              variant={"h1"}
              className={`text-magenta filter-brightness-150`}
              content={"PERSONALIZE YOUR STAY"}
            />
            <p className="text-darkAsh text-[13px] flex justify-center mt-[4px] font-light uppercase mb-[32px]">
              OPTIONAL
            </p>
            <StayOptions />
          </>
        }
        VariantB={
          <>
            <Count className={"mb-0"} count={"2"} />
            <div className="uppercase text-magenta filter-brightness-150 text-center leading-[15.6px] text-[13px] font-light" >Select your room</div>
            {roomState?.roomCounts?.map((room, idx) => {
              return (
                <>
                  {room.isActive ? (
                    roomState?.selectedRooms?.[idx] &&
                    Object.keys(roomState?.selectedRooms[idx])?.length > 0 ? (
                      <>
                      {
                        roomState?.roomCounts?.length > 1 &&  <div className='flex justify-center'>
                          <p className='text-magenta2 font-light text-[16px] mb-[-10px] mt-[22px] max-w-[500px] flex-1 uppercase'>
                            Room {idx + 1}
                          </p>
                        </div>
                      } 
                        <SelectedRoom idx={idx} />
                      </>
                    ) : (
                      <>
                        {
                        roomState?.roomCounts?.length > 1 &&  <div className='flex justify-center'>
                          <p className='text-magenta2 font-light text-[16px] mb-[-10px] mt-[22px] max-w-[500px] flex-1 uppercase'>
                            Room {idx + 1}
                          </p>
                        </div>
                        } 
                        <AvailableRoom
                          for_DK_PK={true}
                          isCollapse={true}
                          callback={() => setRoomCollapse(false)}
                        />
                      </>
                    )
                  ) : null}

                  {room.isActive ? (
                    <>
                      <AvailableRoom
                        isCollapse={roomCollpase}
                        for_DK_PK={true}
                        TitleComp={
                          <CollapseTitle
                            openLabel='Hide More Rooms'
                            closeLable='View More Rooms'
                            className={`ml-auto mt-[30px] mr-auto filter-brightness-150`}
                            onClick={() => setRoomCollapse(!roomCollpase)}
                            flag={roomCollpase}
                          />
                        }
                        callback={() => setRoomCollapse(false)}
                        showAllRoom={true}
                      />

                      {/* COLLAPSE PACKAGES */}
                      <StayOptions forDefaultView={true} roomIndex={idx} />
                      <CollapseTitle
                        openLabel={
                          roomState?.selectedRoom?.length > 0
                            ? 'Hide More Packages'
                            : 'Hide Packages'
                        }
                        closeLable={
                          roomState?.selectedRoom?.length > 0
                            ? 'View More Packages'
                            : 'View Packages'
                        }
                        className={`ml-auto mr-auto my-[25px] text-magenta filter-brightness-150`}
                        onClick={() => setPackageCollapse(!packageCollpase)}
                        flag={packageCollpase}
                      />
                      <Collapse
                        className='pt-1'
                        timeout={2000}
                        in={packageCollpase}
                      >
                        <StayOptions roomIndex={idx} />
                      </Collapse>
                    </>
                  ) : (
                    <>
                      {roomState?.selectedRooms?.[idx] &&
                      Object.keys(roomState?.selectedRooms[idx])?.length > 0 ? (
                        <CustomBox
                          onClick={() => {
                            setRoomCollapse(false);
                            dispatch(setRoomIsActive(idx));
                            // if (!Object.keys(roomState?.selectedRooms?.[idx] || {})?.length > 0) {
                              dispatch(triggerRoomApi());
                            // }
                          }}
                          className='pl-[14px] pr-[14px] pt-[11px] pb-[11px] mb-[10px] flex justify-between'
                          sx={{ marginTop: '35px' }}
                          index={idx}
                          showRemoveButton={false}
                        >
                          <div className='flex flex-col w-full'>
                            <div className='flex justify-between'>
                               <div className="text-[10px] uppercase">Room {idx + 1}</div>
                              <div className="text-[10px] uppercase" onClick={(e) => handleRoomRemove(idx, e)}>Remove</div>
                            </div>
                            <div className='flex justify-between mt-[10px]'>
                              <div>{roomState?.selectedRooms?.[idx]?.name}</div>
                              <div>
                                ${' '}
                                {roomState?.selectedRooms?.[
                                  idx
                                ]?.amount?.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </CustomBox>
                      ) : (
                        <CustomBox
                          onClick={() => {
                            setRoomCollapse(false);
                            dispatch(setRoomIsActive(idx));
                            // if (!Object.keys(roomState?.selectedRooms?.[idx] || {})?.length > 0) {
                              dispatch(triggerRoomApi());
                            // }
                          }}
                          className='pl-[14px] pr-[14px] pt-[11px] pb-[11px] mb-[10px] flex justify-between'
                          sx={{ marginTop: '35px' }}
                          index={idx}
                          showRemoveButton={false}
                        >
                          <div className='flex flex-col w-full'>
                            <div className='flex justify-between'>
                              <div className="text-[10px] uppercase">Room {idx + 1}</div>
                              <div className="text-[10px] uppercase" onClick={(e) => handleRoomRemove(idx, e)}>Remove</div>
                            </div>
                            <div className='flex justify-between mt-[10px]'>
                              <div>Please Select Room</div>
                              <div>$00.00</div>
                            </div>
                          </div>
                        </CustomBox>
                      )}
                    </>
                  )}
                </>
              );
            })}
            {/* {roomState?.selectedRoom?.length > 0 ?
              <SelectedRoom />
              : 
            (
            <AvailableRoom
            for_DK_PK={true}
            isCollapse={true}
            callback={() => setRoomCollapse(false)}
           />
            )} */}

          </>
        }
      />
    </CustomContainer>
  );
}

export default SectionB;